import { PayloadAction } from '@reduxjs/toolkit';
import { message } from 'antd';
import { put, takeLatest } from 'redux-saga/effects';
import {
  bulkAllocationUploadFailure,
  bulkAllocationUploadReq,
  bulkAllocationUploadSuccess,
} from 'redux/slice/allocation/BulkAllocation.slice';
import {
  BulkAllocationUploadRequest,
  BulkAllocationUploadResponse,
} from 'redux/types/Allocation.types';
import { allocationEndpoints } from 'services/api/endPoints';
import { HTTPClient } from 'services/api/http-client';

function* bulkAllocationUploadSaga(
  action: PayloadAction<BulkAllocationUploadRequest>
) {
  try {
    const {
      allocationFile,
      bucket,
      product,
      outstanding,
      channel,
      allocatorName,
      allocatorId,
      startDate,
      endDate,
    } = action.payload;

    const formData = new FormData();
    formData.append('allocationFile', allocationFile);
    formData.append('bucket', JSON.stringify(bucket));
    formData.append('product', JSON.stringify(product));
    formData.append('outstanding', outstanding);
    if (channel && channel.length > 0) {
      formData.append('channel', JSON.stringify(channel));
    }
    formData.append('allocatorName', allocatorName);
    formData.append('allocatorId', allocatorId);
    formData.append('startDate', startDate);
    formData.append('endDate', endDate);

    const response: { data: BulkAllocationUploadResponse } =
      yield HTTPClient.PostRequest(
        allocationEndpoints.BULK_ALLOCATION_UPLOAD,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

    yield put(bulkAllocationUploadSuccess(response.data));
    message.success(
      response.data.message || 'Bulk allocation uploaded successfully'
    );
  } catch (error: any) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to upload bulk allocation';
    yield put(bulkAllocationUploadFailure(errorMessage));
    message.error(errorMessage);
  }
}

export function* watchBulkAllocationSagas() {
  yield takeLatest(bulkAllocationUploadReq.type, bulkAllocationUploadSaga);
}
